// Public UI adapted from Klargo-Reference/components/common/KlargoLogo.tsx.
import React from 'react';
import klargoLogo from '../../assets/klargo-logo.png';
export const KlargoLogo = ({ variant = 'hero', onClick, ariaLabel = 'Till startsidan', }) => {
    const sizeClass = variant === 'hero' ? 'h-12' : 'h-12';
    const img = (<img src={klargoLogo} alt="Klargo" className={`${sizeClass} w-auto`}/>);
    if (onClick) {
        return (<button onClick={onClick} className="cursor-pointer rounded" aria-label={ariaLabel}>
        {img}
      </button>);
    }
    return img;
};
export default KlargoLogo;
